import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { TextBox } from "../../core/components/textBox";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import EditTranslations from "../editTranslations";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react";
export default class EditTicketMedium extends React.Component<EditTicketMediumProps, EditTicketMediumState> {
    private _factory = ComponentHelper.createFactory();
    private _editTranslationsRef: EditTranslations = null;
    private _gridOptions: any;
    private _translations: string[] = [];
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (!Helper.isNullOrEmpty(this.state.currentMedium.Name)) {
                        this._save();
                    } else {
                        DialogHelper.alert(this._translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {            
            this.setState({ dialogOpen: false });
        },
        width: 500
    };


    constructor(props: EditTicketMediumProps) {
        super(props);
        this._gridOptions = props.context.editTicketMediumGridOptions;
        this._translations = props.context.translations;
        this.state = {
            gridData: [],
            dialogOpen: false,
            currentMedium: null,
            enableDeleteButton: false
        };
    }

    private _save = () => {
        HTTPService.post <JsonResultClass>("GeneralSettings/SaveTicketMedium", { model: this.state.currentMedium })
            .then(result => {
                if (result.Code == 0) {
                    this._getGridData();
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private _getGridData = () => {
        const url = "GeneralSettings/GetTicketMediums";
        HTTPService.get<JsonResultClass<Medium[]>>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }


    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this._createTextBox()}
                        {this._createTranslationLabel()}
                    </FullHeightContainer>
                    <EditTranslations
                        ref={(r) => this._editTranslationsRef = r}
                        label={Config.translations.editLabel}
                        saveGerman={(value: string) => {
                            let medium = this.state.currentMedium;
                            medium.GermanName = value;
                            this.setState({ currentMedium: medium });
                        }}
                    />
                </Dialog>
            </div>
        );
    }

    private _createTextBox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = this.state.currentMedium.Name;
        props.onChange = (field: { model: string }, value: any) => {
            let model = this.state.currentMedium;
            model.Name = value;
            this.setState({})
        }

        return (
            <FieldInstance label={this._translations["Standard.Name"] + "*"} noHover={true}>
                <TextBox {...props} />

            </FieldInstance>
            );
    }

    private _createTranslationLabel = () => {
        if ((!this.state.currentMedium.IsNew) && (Helper.hasValue(this.state.currentMedium.IsRowId))) {
            const labelStyle: React.CSSProperties = {
                cursor: "pointer",
                textDecoration: "Underline"
            }
            const divStyle: React.CSSProperties = {
                display: "flex",
                justifyContent: "flex-end",
                fontSize: "10px",
                marginTop: "2px"
            }
            return (
                <FieldInstance noLabel={true}>
                    <div style={divStyle}>
                        <label
                            style={labelStyle}
                            onClick={this._openTranslationsDialog}>{this._translations["WebSMS.GeneralSettings.UebersetzungenBearbeiten"]}
                        </label>
                    </div>
                </FieldInstance>);
        } else {
            return <></>;
        }
    }

    private _openTranslationsDialog = () => {
        this._editTranslationsRef.openDialog(this.state.currentMedium.IsRowId, 289, "value_0", this.state.currentMedium.GermanName);
    }

    private _openDialog = (dataItem: Medium = null) => {
        if (!Helper.hasValue(dataItem)) {
            dataItem = {
                Id: -1,
                IsDeleteable: true,
                IsNew: true,
                IsRowId: null,
                Name: "",
                GermanName: ""
            }
        }
        this.setState({ currentMedium: dataItem, dialogOpen: true });
    }

    private _delete = (dataItem: Medium) => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>("GeneralSettings/DeleteTicketMedium", { model: dataItem })
                    .then(result => {
                        if (result.Code == 0) {
                            this._getGridData();
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });



    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Medium) => {
        switch (type) {
            case (ToolBarStandardButtonType.NEW):
                this._openDialog();
                break;
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem);
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._delete(dataItem);
                break;
        }
    }

    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.enableDeleteButton });


        let grid = (
            <Grid data={this.state.gridData} options={this._gridOptions} id="generalSettings_TicketMediaGrid"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} onSelectionChanged={this._onSelectionChanged} />
        );
        return (grid)
    }

    _onSelectionChanged = (dataItem: Medium) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ enableDeleteButton: dataItem.IsDeleteable });
        } else {
            this.setState({ enableDeleteButton: false });
        }
    }

    componentDidMount() {
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : null;
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div className="flex-container flex-container__item" style={{ height: "300px" }}>
                    {grid}
                    {dialog}
                </div>
            </div>);

    }
};

interface EditTicketMediumProps {
    context: ContextGeneralSettingsApp;
}

interface EditTicketMediumState {
    gridData: Medium[];
    enableDeleteButton: boolean;
    dialogOpen: boolean;
    currentMedium: Medium;
}

interface Medium {
    Id: number;
    Name: string;
    GermanName: string;
    IsRowId: number;
    IsDeleteable: boolean;
    IsNew: boolean;
}